import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getLanguageFromPath, stripLocalePrefix } from '@/hooks/useLocalePath';

const DOMAIN = 'https://dealigator.bg';

const langToHtmlLang: Record<string, string> = {
  bg: 'bg',
  en: 'en',
  ru: 'ru',
};

/**
 * Dynamically injects hreflang <link> tags into <head> and updates <html lang>.
 */
const HreflangTags = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const currentLang = getLanguageFromPath(pathname);
    const basePath = stripLocalePrefix(pathname);
    const normalizedBase = basePath === '/' ? '' : basePath;

    // Update <html lang>
    document.documentElement.lang = langToHtmlLang[currentLang] || 'en';

    const hreflangs = [
      { lang: 'bg', href: `${DOMAIN}${normalizedBase || '/'}` },
      { lang: 'en', href: `${DOMAIN}/en${normalizedBase || ''}` },
      { lang: 'ru', href: `${DOMAIN}/ru${normalizedBase || ''}` },
      { lang: 'x-default', href: `${DOMAIN}/en${normalizedBase || ''}` },
    ];

    // Clean up any existing hreflang tags
    document.querySelectorAll('link[data-hreflang]').forEach((el) => el.remove());

    // Add new hreflang tags
    hreflangs.forEach(({ lang, href }) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;
      link.href = href;
      link.setAttribute('data-hreflang', 'true');
      document.head.appendChild(link);
    });

    return () => {
      document.querySelectorAll('link[data-hreflang]').forEach((el) => el.remove());
    };
  }, [pathname]);

  return null;
};

export default HreflangTags;
